import React from "react";
import { connect } from "react-redux";
import { Selectors, State } from "../store/reducer";
import { Redirect, Route, RouteProps } from "react-router";

export interface AuthCheckOptions {
  shouldBeAuth: boolean;
  redirectTo: string;
}
export interface AuthRouteProps extends RouteProps{
  isAuthenticated?: boolean;
}
export default ({
  shouldBeAuth,
  redirectTo
}: AuthCheckOptions) => {

  const AuthRoute: React.SFC<AuthRouteProps> = ({ isAuthenticated, component: Component, ...props }) => {
    return (
      <Route
        {...props}
        render={routeProps =>
          shouldBeAuth !== isAuthenticated ? (
            <Redirect to={redirectTo} />
          ) : (
            <Component {...routeProps} />
          )
        }
      />
    );
  };
  return connect((state: State) => ({
    isAuthenticated: Selectors.isAuthenticated(state)
  }))(AuthRoute);
};



// WEBPACK FOOTER //
// ./src/routes/withAuthCheck.tsx